import { useCallback, useEffect, useRef, useState } from 'react';
var DEFAULT_VISIBLE_LINKS_AMOUNT = 4;

var isElementVisible = function isElementVisible(el) {
  return el && !!el.offsetParent;
};

var elementsNotVisible = function elementsNotVisible(linksDiv, actionsDiv) {
  return !isElementVisible(linksDiv) && !isElementVisible(actionsDiv);
};

var noMoreLinksToOverflow = function noMoreLinksToOverflow(overflowLinks, totalLinks) {
  return overflowLinks >= totalLinks;
};

export var useFitLinksInNav = function useFitLinksInNav(totalLinks) {
  var _useState = useState(Math.max(totalLinks - DEFAULT_VISIBLE_LINKS_AMOUNT, 0)),
      overflowLinks = _useState[0],
      setOverflowLinks = _useState[1];

  var overflowLinksRef = useRef(overflowLinks);
  var toolbarRef = useRef(null);
  var actionsRef = useRef(null);
  var spaceRef = useRef(null);
  var linksRef = useRef(null);
  var handleResize = useCallback(function () {
    var _spaceRef$current, _linksRef$current, _actionsRef$current;

    if (elementsNotVisible(linksRef.current, actionsRef.current) || noMoreLinksToOverflow(overflowLinksRef.current, totalLinks)) return;
    var spaceAvailable = ((_spaceRef$current = spaceRef.current) === null || _spaceRef$current === void 0 ? void 0 : _spaceRef$current.getBoundingClientRect().width) || 0;
    var totalWidth = (((_linksRef$current = linksRef.current) === null || _linksRef$current === void 0 ? void 0 : _linksRef$current.getBoundingClientRect().width) || 0) + spaceAvailable + (((_actionsRef$current = actionsRef.current) === null || _actionsRef$current === void 0 ? void 0 : _actionsRef$current.getBoundingClientRect().width) || 0) + 48;

    if (Math.floor(totalWidth) > window.innerWidth) {
      overflowLinksRef.current++;
      return setOverflowLinks(overflowLinksRef.current);
    }

    if (spaceAvailable > 150 && overflowLinksRef.current > 0) overflowLinksRef.current--;
    setOverflowLinks(overflowLinksRef.current);
  }, [actionsRef, totalLinks, overflowLinksRef, linksRef, spaceRef]);
  useEffect(function () {
    var resizeObserver = new ResizeObserver(handleResize);
    if (toolbarRef.current) resizeObserver.observe(toolbarRef.current);
    if (linksRef.current) resizeObserver.observe(linksRef.current);
    if (actionsRef.current) resizeObserver.observe(actionsRef.current);
    return function () {
      return resizeObserver.disconnect();
    };
  }, [toolbarRef.current, linksRef.current, actionsRef.current]);
  return {
    toolbarRef: toolbarRef,
    actionsRef: actionsRef,
    spaceRef: spaceRef,
    linksRef: linksRef,
    overflowLinks: overflowLinks
  };
};